import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useGlobal } from "reactn";
import MediaQuery from "components/MediaQuery";
import ChampionRankingStats from "components/Champions/ChampionRankingStats";
import Skills from "./Skills";
import ArenaItems from "./ArenaItems";
import AdComponent from "components/Ads/AdComponent";
import { getNotFoundImg } from "@outplayed/riot-assets";

import { useUserPremiumState } from "lib/hooks/userHooks";
import { getChampionTransformId } from "lib/general-helper.js";
import BuildTabs from "./BuildTabs";
import { ArenaSynergies } from "@ugg/shared/components/Champions/pages/Arena/Synergies";
import { ArenaAugments } from "@ugg/shared/components/Champions/pages/Arena/Augments";

const ArenaBuild = (props) => {
  const [loggingIn] = useGlobal("loggingIn");
  const location = useLocation();
  const { pathname } = location || {};
  const { isPremium } = useUserPremiumState();

  const sectionRef = useRef();

  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (sectionRef.current) {
      setHeight(sectionRef.current.offsetHeight);
    }
  }, []);

  const {
    page,
    version,
    championId,
    championData,
    championOverview,
    fetchingData,
    filteredRankingStats,
    otpStats,
    role,
    filters,
    missingMatchup,
    queueTypeName,
    renderAdditionalStats,
    championModifications,
    tabData,
    defaultBuild,
    setDefaultBuild,
    isAP,
    isTank,
    isAD,
    isCrit,
    isLethality,
    isOnHit,
    isRed,
    isBlue,
    match,
  } = props;

  if (fetchingData) {
    return (
      <div className="champion-recommended-build">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  let {
    rec_starting_items,
    rec_core_items,
    rec_skills,
    rec_skill_path,
    rec_skill_evolve_path,
    item_options_1,
    item_options_2,
    item_options_3,
    consumable_options,
    arena_synergies,
    arena_augments,
  } = championOverview || {};

  if (
    !rec_starting_items ||
    !rec_core_items ||
    !rec_skills ||
    !rec_skill_path ||
    !item_options_1 ||
    !item_options_2 ||
    !item_options_3
  ) {
    return (
      <div className="content-section champion-profile-error champion-recommended-build">
        <img className="not-found" src={getNotFoundImg()} alt="No data found" />
        No data found. Please try again or change filters.
      </div>
    );
  }

  const championName = championData.name;
  const multi = match.params.multi;

  return (
    <div className="champion-recommended-build ">
      <div className="additional-stats-container">
        <ChampionRankingStats
          rankingStats={filteredRankingStats}
          oppChampionOverview={filters.opp && championOverview}
          opp={filters.opp}
          queueType={filters.queueType}
          missingMatchup={missingMatchup}
          renderSpecialStats={renderAdditionalStats}
        />
      </div>
      <div className="arena-synergies-and-augments mt-[18px] gap-[1px] flex max-sm:flex-col max-sm:gap-[12px]">
        <ArenaSynergies
          className="flex-1 rounded-tl-[3px] rounded-bl-[3px] max-sm:rounded-[3px] overflow-hidden"
          championId={championId}
          data={arena_synergies || []}
          patch={version}
        />
        <ArenaAugments
          className="flex-1 rounded-tr-[3px] rounded-br-[3px] max-sm:rounded-[3px] overflow-hidden"
          championId={championId}
          data={arena_augments || []}
          patch={version}
        />
      </div>
      <Skills
        championId={getChampionTransformId(championId)}
        skillPriority={rec_skills}
        skillPath={rec_skill_path}
        evolutionPath={rec_skill_evolve_path}
        championName={championName}
      />
      <ArenaItems
        startingItems={rec_starting_items}
        coreItems={rec_core_items}
        items1={item_options_1}
        items2={item_options_2}
        items3={item_options_3}
        consumables={consumable_options}
        patch={version}
        championName={championName}
      />
    </div>
  );
};

export default ArenaBuild;
